export default "__VITE_ASSET__DObmzEy1__"